import Button from "./Button";
const ButtonList=()=>{
    return(
        <div className="ButtonList">
            <Button name="All"/>
            <Button name="Mixes"/>
            <Button name="Music"/>
            <Button name="Live"/>
            <Button name="Prodcast"/>
            <Button name="Astronomy"/>
            <Button name="Gaming"/>
            <Button name="Codeing"/>
            <Button name="LifeStyle"/>
            <Button name="News"/>
            <Button name="Gym"/>
            <Button name="Movie"/>
            <Button name="Technology"/>
            <Button name="Product"/>
            <Button name="Ideas"/>
            <Button name="Bussiness"/>
            <Button name="Skills"/>
        </div>
    );
}
export default ButtonList;